import { useState, useEffect } from 'react'
import { CoreForm } from '../../components/CoreForm'
import { message } from 'antd'
import { TableData } from '../../components/TableData'
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import { apiGetList, apiDelete, apiUpdate, apiCount } from '../../api/crud'
import { useNavigate } from 'react-router-dom'
import type { TableColumnsType } from 'antd'

interface DataType {
  key: React.Key
  id: number
  name: string
  price_per_minute: string
  is_active: boolean
}

const Plan = () => {
  const [messageApi, contextHolder] = message.useMessage({ duration: 5 })
  const [data, setData] = useState<Api.Response.Plans[]>()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [total, setTotal] = useState<number>(10)
  const url = 'plan'
  const nav = useNavigate()

  const getData = async (params: Api.Params.Pagination) => {
    setLoading(true)
    const result = await apiGetList('plan', params)
    if (result.isError) {
      messageApi.error('Ошибка загрузки данных')
      setLoading(false)
      return
    }
    setLoading(false)
    return result.data
  }
  const getTotal = async () => {
    const result = await apiCount(url)
    if (result.isError) {
      messageApi.error('Ошибка загрузки данных')
      return
    }
    return result.data
  }

  useEffect(() => {
    const params = {
      offset: (page - 1) * pageSize,
      limit: pageSize
    }
    getData(params).then((data: any) => data && setData(data))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, total])

  useEffect(() => {
    getTotal().then((data: any) => data && setTotal(data))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const columns: TableColumnsType<DataType> = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.id - b.id
    },
    {
      title: 'Название',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Цена/минута',
      dataIndex: 'price_per_minute',
      key: 'price_per_minute'
    },
    {
      title: 'Активен',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (value: boolean) =>
        value ? (
          <CheckCircleFilled style={{ color: 'green', widows: '24px' }} />
        ) : (
          <CloseCircleFilled style={{ color: 'red', widows: '24px' }} />
        )
    }
  ]

  const handelAdd = () => {
    nav('/admin/plan/create')
  }

  const handelDelete = async (ids: Array<any>) => {
    ids.map(async id => {
      const result = await apiDelete(url, id)
      if (result.isError) {
        messageApi.error('При удалении тарифа произошла ошибка')
      }
      messageApi.error('Тариф удален')
      setTotal(prev => prev - 1)
    })
  }

  const handelBlock = (ids: Array<any>) => {
    ids.map(async id => {
      const result = await apiUpdate(url, id, { is_active: false })
      if (result.isError) {
        messageApi.error('При выключении тарифа произошла ошибка')
      }
      messageApi.error('Тариф отключен')
      setTotal(prev => prev - 1)
    })
  }

  const handelUnBlock = (ids: Array<any>) => {
    ids.map(async id => {
      const result = await apiUpdate(url, id, { is_active: true })
      if (result.isError) {
        messageApi.error('При включении тарифа произошла ошибка')
      }
      messageApi.success('Тариф включен')
      setTotal(prev => prev - 1)
    })
  }

  const buttons: Array<TableDataType.Button> = [
    {
      title: 'Добавить',
      onClick: handelAdd
    },
    {
      title: 'Удалить',
      danger: true,
      onClickWithSelectedRow: handelDelete
    },
    {
      title: 'Отключить',
      onClickWithSelectedRow: handelBlock
    },
    {
      title: 'Включить',
      onClickWithSelectedRow: handelUnBlock
    }
  ]
  return (
    <>
      {' '}
      {contextHolder}
      <CoreForm title='Тарифы'>
        <TableData
          loading={loading}
          items={data}
          columns={columns}
          buttons={buttons}
          routeDetail={url}
          pagination={{ page, pageSize, total, setPage, setPageSize }}
        />
      </CoreForm>
    </>
  )
}

export default Plan
